module.exports = __webpack_public_path__ + "img/relief-bg-shape.920e7079.png";